import React, { ReactNode, useState } from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { Title } from '../../atoms/title/Title'
import { HorizontalTabs } from '../../molecules/horizontalTabs/HorizontalTabs'
import { TitleSize } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'
import { TabItem } from '../horizontalTabsContainer/HorizontalTabsContainer'

export type ProviderDashboardCardProps = {
  title: ReactNode
  tabs: TabItem[]
  onTabChange?: (id: string) => void
  style?: ViewStyle
  defaultActiveTabId?: string
  activeTabId?: string
}

const Card = styled.View(({ theme }) => ({
  backgroundColor: theme.colors.backgroundPrimary,
  borderWidth: '1px',
  borderColor: theme.colors.borderDefault,
  borderRadius: theme.spacing['16px'],
  overflow: 'hidden',
}))

const TabContent = styled.View({
  flexShrink: 1,
})

const TitleRow = styled.View(({ theme }) => ({
  paddingHorizontal: theme.spacing['16px'],
  paddingTop: theme.spacing['16px'],
}))

const TabBar = styled.View(({ theme }) => ({
  paddingHorizontal: theme.spacing['16px'],
  borderBottomWidth: '1px',
  borderBottomColor: theme.colors.borderDefault,
}))

export const ProviderDashboardCard: React.FC<ProviderDashboardCardProps> = ({
  title,
  tabs,
  onTabChange,
  style,
  defaultActiveTabId,
  activeTabId: controlledActiveTabId,
}) => {
  const isControlled = controlledActiveTabId !== undefined
  const [uncontrolledActiveTabId, setUncontrolledActiveTabId] = useState(
    defaultActiveTabId && tabs.some((tab) => tab.id === defaultActiveTabId)
      ? defaultActiveTabId
      : tabs.length > 0
        ? tabs[0].id
        : '',
  )
  const activeTabId = isControlled ? controlledActiveTabId : uncontrolledActiveTabId
  const activeTab = tabs.find((tab) => tab.id === activeTabId)

  const handleTabChange = (id: string) => {
    if (!isControlled) {
      setUncontrolledActiveTabId(id)
    }
    onTabChange?.(id)
  }

  return (
    <Card testID={tID('ProviderDashboardCard')} style={style}>
      <TitleRow>
        <Title size={TitleSize.MEDIUM} text={title} />
      </TitleRow>
      <TabBar>
        <HorizontalTabs
          tabs={tabs.map((tab) => ({ id: tab.id, label: tab.label, iconWithTooltip: tab.iconWithTooltip }))}
          onPress={handleTabChange}
          selectedTabId={activeTabId}
          testID={tID('ProviderDashboardCard')}
          tabStyle={{ paddingVertical: 12 }}
        />
      </TabBar>
      <TabContent>{activeTab?.content}</TabContent>
    </Card>
  )
}
